var o=(r=>(r.UPDATE="updated",r.CREATE="created",r.DELETE="deleted",r.ATTACH="attach",r.DETACH="detach",r.RESTORE="restored",r))(o||{});

export { o as a };
//# sourceMappingURL=chunk-MPHL6OWK.js.map
//# sourceMappingURL=chunk-MPHL6OWK.js.map